<template>
  <a-card :bordered="false">
 
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect />
<!--              <a-cascader @change="onSjsqChange" :options="sjsqOptions"-->
<!--                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }"-->
<!--                          placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect-->
<!--              />-->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear>
                <a-select-option value="1">未开始</a-select-option>
                <a-select-option value="2">进行中</a-select-option>
                <a-select-option value="3">已结束</a-select-option>
                <a-select-option value="4">成绩发布</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="考试时间">
                <a-range-picker
                    v-model="time_range_moment"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
 
      <a-dropdown style="margin-left: 8px">
      <a-menu slot="overlay" >
        <a-menu-item key="1" @click="handleAdd(2)">
         预赛
        </a-menu-item>
        <a-menu-item key="2" @click="handleAdd(1)">
         决赛
        </a-menu-item> 
      </a-menu>
      <a-button> 新增单组场次 <a-icon type="plus" /> </a-button>
    </a-dropdown>

      <a-dropdown style="margin-left: 8px">
      <a-menu slot="overlay" >
        <a-menu-item key="1" @click="handleMoreAdd(2)">
         预赛
        </a-menu-item>
        <a-menu-item key="2" @click="handleMoreAdd(1)">
         决赛
        </a-menu-item> 
      </a-menu>
      <a-button> 新增多组场次 <a-icon type="plus" /> </a-button>
    </a-dropdown>
 
      <a-button @click="handleDownload" style="margin-left: 8px">
        出场顺序批量下载
        <a-icon type="download"/>
      </a-button>
      <a-button  @click="download(7)">奖杯贴信息表
        <a-icon type="download"/>
      </a-button>
      <!--            <a-button  @click="handleZhixuDownload" style="margin-left: 8px">-->
      <!--                秩序册下载-->
      <!--                <a-icon type="download"/>-->
      <!--            </a-button>-->
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="title1" slot-scope="text,record">
          <div style="margin-left: 10px; float: left"> 
            {{ record.title }}<a-tag v-if="record.type==1" color="#108ee9">决赛</a-tag>
            <a-tag v-else color="blue">预赛</a-tag> 
            <!--<br/><span style="color: #999">{{record.mingcheng}}</span>-->
            <br/>
            {{ record.create_time|timeFormat }}
            <br/>
          </div>
      </span>
      <span slot="saiqu" slot-scope="text,record">
        {{ record.saiqu_name }}
      </span>
      <span slot="status" slot-scope="text,record">
        <a-dropdown :trigger="['click']">
        <a-tag v-if="record.status==1">未开始 <a-icon type="form"/></a-tag>
        <a-tag v-else-if="record.status==2" color="green">进行中 <a-icon type="form"/></a-tag>
        <a-tag v-if="record.status==3">结束 <a-icon type="form"/></a-tag>
        <a-tag v-if="record.status==4" color="red">成绩发布 <a-icon type="form"/></a-tag>
    <a-menu slot="overlay" >
      <a-menu-item key="0" @click="setStatus(1,record)" v-if="record.status==1 || record.status==2">
        <a>未开始</a>
      </a-menu-item>
      <a-menu-item key="1" @click="setStatus(2,record)" v-if="record.status==1 || record.status==2 || record.status==3">
        <a>进行中</a>
      </a-menu-item>
      <a-menu-item key="3" @click="setStatus(3,record)" v-if="record.status==2 || record.status==3 || record.status==4">
        <a>结束</a>
      </a-menu-item>
<!--      <a-menu-item key="4" @click="setStatus(4,record)" v-if="record.status==3 || record.status==4">-->
      <a-menu-item key="4" @click="setStatus(4,record)" v-if=" record.status==4">
        <a>成绩发布</a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>


        <a-dropdown :trigger="['click']"> 
        <a-tag v-if="record.is_show==1" color="green">前台可见 <a-icon type="form"/></a-tag>
        <a-tag v-else-if="record.is_show==2">前台不可见 <a-icon type="form"/></a-tag> 
    <a-menu slot="overlay" >
      <a-menu-item key="0" @click="setShow(2,record)" v-if="record.is_show==1 ">
        <a>前台不可见</a>
      </a-menu-item>
      <a-menu-item key="1" @click="setShow(1,record)" v-if="record.is_show==2 ">
        <a>前台可见</a>
      </a-menu-item> 
    </a-menu>
  </a-dropdown> 

      </span>
      <span slot="action" slot-scope="text,record" >
        <template>
          <a @click="handleEdit(record)">出场顺序</a>
          <a-divider type="vertical"/>
            <a @click="handleTimeEdit(record)">时间设置</a>
             <a-divider type="vertical"/>
            <a @click="downloadSubject(record)">出场顺序下载</a>
            <a-divider type="vertical"/>
            <a @click="handleMusicDownload(record)">音乐下载</a>
            <a-divider type="vertical"/>
          <a @click="handleUserManage(record)">裁判设置</a>
          <a-divider type="vertical"/>
           <a @click="handleDataOpen(record)">数据展示</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="startListDelete(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>

    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :centered="true"
        :bodyStyle="{maxHeight:'600px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="chuchangSaveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="场次标题"
                  hasFeedback
              >
                <a-input v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入场次标题' }]}
        ]"
                         placeholder="例如xx月xx日第xx场"/>
              </a-form-item>
            </a-col> 

            <!--                        <a-col :md="12" :sm="24">-->
            <!--                            <a-form-item-->
            <!--                                    :labelCol="labelCol"-->
            <!--                                    :wrapperCol="wrapperCol"-->
            <!--                                    label="比赛用时"-->
            <!--                                    hasFeedback-->
            <!--                            >-->
            <!--                                <a-time-picker :default-open-value="moment(formData.saiTime, 'HH:mm:ss')"-->
            <!--                                               :value="moment(saiTimeTotal, 'HH:mm:ss')"-->
            <!--                                               @change="onTimeTotalChange"/>-->
            <!--                            </a-form-item>-->
            <!--                        </a-col>-->
            <!--                        <a-col :md="6" :sm="24">-->
            <!--                            <a-form-item-->
            <!--                                    :labelCol="wrapperCol"-->
            <!--                                    :wrapperCol="wrapperCol"-->
            <!--                                    label="是否开启多组裁判"-->
            <!--                                    hasFeedback-->
            <!--                            >-->
            <!--                                <a-switch v-model="formData.is_more_caipan" checked-children="开启"-->
            <!--                                          un-checked-children="关闭"-->
            <!--                                          @click="onCaipanChange"/>-->
            <!--                            </a-form-item>-->
            <!--                        </a-col>-->

          </a-row>
          <a-transfer
              :dataSource="mingdanList"
              showSearch
              class="subject-transfer"
              :listStyle="{
                width: '48%',
                height:'500px'
              }"
              :filterOption="mingdanFilterOption"
              :targetKeys="mingdanTargetKeys"
              @change="mingdanHandleChange"
              @selectChange="mingdanHandleSelectChange"
              @search="mingdanHandleSearch"
              :render="renderItem"
          >
            <div
                slot="footer"
                class="footer-btn"
                slot-scope="props">
              <a-button

                  size="small"
                  style="margin: 5px"
                  @click="mingdanUp"
              >
                上移
              </a-button>
              <a-button
                  size="small"
                  style="margin: 5px"
                  @click="mingdanDown"
              >
                下移
              </a-button>

            </div>
          </a-transfer>
        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="gxSaveFlag=false;handleOk()">保存</a-button>
        <a-button key="forward2" v-show="gxSaveShow" :loading="saveLoading" type="primary" @click="gxSaveFlag=true;handleOk()">强力保存</a-button>
      </template>
    </a-modal>
    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :centered="true"
        :bodyStyle="{maxHeight:'600px','overflowY':'scroll'}"
        v-model="visibleMore"
        @ok="handleMoreOk"
    >
      <a-spin :spinning="chuchangSaveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="场次标题"
                  hasFeedback
              >
                <a-input v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入场次标题' }]}
        ]"
                         placeholder="例如xx月xx日第xx场"/>
              </a-form-item>
            </a-col>
          </a-row>
          <div class="subject-box">
            <div class="subject-left subject-with-header">
              <div class="subject-header">
                <a-checkbox :indeterminate="indeterminate" :checked="checkAll"
                            @change="onCheckAllChange">
                  {{ mingdanLeftList.length + '项' }}
                </a-checkbox>

                <!--                                级联选择-->

                <div style="width: 80%">
                  <!-- <a-cascader @change="onSubjectChange" size="small" :options="subjectOptions"
                              :fieldNames="{ label: 'name', value: 'key', children: 'children' }"
                              placeholder="请选择项目" v-model="queryParam.subject" changeOnSelect
                  /> -->
                          <a-input v-model="subjectKeywords" style="width: 280px" @change="onSubjectNameFilter"
                                  size="small" allow-clear clearable placeholder="请输入项目名称搜索"/>
                </div>

              </div>
              <div class="subject-content">
                <a-table :pagination="false" :columns="testColumns" :dataSource="mingdanLeftList"
                         rowKey="id"
                         :row-selection="{ selectedRowKeys: subjectLeftSelectedKeys, onChange: onSubjectLeftSelectChange }">
                  <div slot="name" slot-scope="text,item" class="beixuandiv">
                    <a-popover title="运动员">
                      <template slot="content">
                        <div style="color:#999;max-width: 450px;word-break: normal">
                          {{ item.yundongyuans }}
                        </div>
                      </template>
                      <span class="custom-item">{{ item.id }} {{ item.mingcheng }}
                                            <br/>
                                            <span style="color:#999">{{ item.subject_name_s }}</span>
                                            <br/>
                  <em v-if="item.score_total>0">预赛成绩:<span style="color:#999">{{item.score_total}}</span> 排名:<span style="color:#999">{{item.rank}}</span></em>
                                       </span>

                    </a-popover>

                    <!--                                        <span style="color:#666">{{item.saiqu_name}}-->
                    <!--                                        </span>-->
                    <!--                                        <br/>运动员 :-->
                    <!--                                        <span style="color:#999">{{item.yundongyuans}}-->
                    <!--                                        </span>-->
                  </div>
                </a-table>

              </div>
            </div>

            <div class="subject-button">
              <div class="button-detail">
                <a-button icon="right" type="primary"
                          :disabled="subjectLeftSelectedKeys.length > 0 ? false : true"
                          @click="toSelectA">选择到A
                </a-button>
                <a-button icon="right" type="primary"
                          :disabled="subjectLeftSelectedKeys.length > 0 ? false : true"
                          @click="toSelectB">选择到B
                </a-button>
                <a-button icon="left" type="primary"
                          :disabled="subjectRightSelectedKeys.length > 0 ? false : true"
                          @click="toSelectLeft">取消
                </a-button>
                <a-button icon="up" type="primary"
                          :disabled="subjectRightSelectedKeys.length > 0 ? false : true"
                          @click="toSelectMoveUp">上移
                </a-button>
                <a-button icon="down" type="primary"
                          :disabled="subjectRightSelectedKeys.length > 0 ? false : true"
                          @click="toSelectMoveDown">下移
                </a-button>

              </div>
            </div>
            <div class="subject-right subject-with-header">
              <div class="subject-row-one" style="width: 100%">
                <div class="subject-row-header">
                  <a-checkbox :indeterminate="indeterminateA" :checked="checkAllA"
                              @change="onCheckAllAChange">
                    A组裁判
                  </a-checkbox>
                </div>
                <div class="subject-two-header">
                  <a-checkbox :indeterminate="indeterminateB" :checked="checkAllB"
                              @change="onCheckAllBChange">
                    B组裁判
                  </a-checkbox>
                </div>
                <div class="subject-content">
                  <a-table :pagination="false" :columns="testColumns2"
                           :dataSource="mingdanRightList"
                           rowKey="id"
                           :row-selection="{ selectedRowKeys: subjectRightSelectedKeys, onChange: onSubjectRightSelectChange }">
                    <div slot="name1" slot-scope="text,item,index"> 
                      <a-popover title="运动员">
                        <template slot="content">
                          <div style="color:#999;max-width: 450px;word-break: normal">
                            {{ item.yundongyuans }}
                          </div>
                        </template>
                        <div v-if="item.jgroup == 0" class="diuiwuitem"
                             style="background: #f8f8f8;text-align: left;padding: 5px 0 5px 5px;">
                          {{index+1}}.
                                                    <span class="custom-item">{{ item.id }} {{ item.mingcheng }}
                                                <br/>
                                                <span style="color:#999">{{ item.subject_name_s }}</span>
                                                <br/>
                                                </span>
                        </div>
                      </a-popover>
                      <!--                                        <span style="color:#666">{{item.saiqu_name}}-->
                      <!--                                        </span>-->
                      <!--                                        <br/>运动员 :-->
                      <!--                                        <span style="color:#999">{{item.yundongyuans}}-->
                      <!--                                        </span>-->

                    </div>
                    <div slot="name2" slot-scope="text,item,index"> 
                      <a-popover title="运动员">
                        <template slot="content">
                          <div style="color:#999;max-width: 450px;word-break: normal">
                            {{ item.yundongyuans }}
                          </div>
                        </template>
                        <div v-if="item.jgroup == 1" class="diuiwuitem"
                             style="background: #f8f8f8;text-align: left;padding: 5px;">
                          {{index+1}}.
                                                    <span class="custom-item">{{ item.id }} {{ item.mingcheng }}
                                                <br/>
                                                <span style="color:#999">{{ item.subject_name_s }}</span>
                                                <br/>
                                                </span>
                        </div>
                      </a-popover>

                      <!--                                        <span style="color:#666">{{item.saiqu_name}}-->
                      <!--                                        </span>-->
                      <!--                                        <br/>运动员 :-->
                      <!--                                        <span style="color:#999">{{item.yundongyuans}}-->
                      <!--                                        </span>-->
                    </div>
                  </a-table>

                </div>
              </div>
            </div>
          </div>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleMoreCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleMoreOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
        title="时间设置"
        :width="1200"
        :centered="true"
        :bodyStyle="{maxHeight:'600px','overflowY':'scroll'}"
        v-model="timeVisible"
        @cancel="handleTimeCancel"
        @ok="handleTimeOk"
    >
      <a-spin :spinning="timeSaveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="4" :sm="24">
              <a-form-item
                  label="检录时间一"
                  hasFeedback
              >
                <a-time-picker :default-open-value="moment(timeData.checkTime1, 'HH:mm:ss')"
                               :value="moment(timeData.checkTime1, 'HH:mm:ss')"
                               @change="onTimeChange1"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item
                  label="检录时间二"
                  hasFeedback
              >
                <a-time-picker :default-open-value="moment(timeData.checkTime2, 'HH:mm:ss')"
                               :value="moment(timeData.checkTime2, 'HH:mm:ss')"
                               @change="onTimeChange2"/>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24">
              <a-form-item
                  label="检录时间三"
                  hasFeedback
              >
                <a-time-picker :default-open-value="moment(timeData.checkTime3, 'HH:mm:ss')"
                               :value="moment(timeData.checkTime3, 'HH:mm:ss')"
                               @change="onTimeChange3"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item
                  label="时间间隔"
                  hasFeedback
              >
                <a-input-number v-model="timeData.timeSpan" style="width: 128px" allowClear
                                placeholder="间隔（分钟）"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item
                  label="比赛时间"
                  hasFeedback
              >
                <a-time-picker :default-open-value="moment(timeData.saiTime, 'HH:mm:ss')"
                               :value="moment(timeData.saiTime, 'HH:mm:ss')"
                               @change="onSaiTimeChange"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item
                  label=""
                  hasFeedback
              >
                <a-button style="margin: 20px 0;" type="primary" @click="onBatchTime">批量设置</a-button>
              </a-form-item>
            </a-col>
          </a-row>

          <!--                    <a-row :gutter="48">-->
          <!--                        <a-col :md="12" :sm="24">-->
          <!--                            <a-form-item-->
          <!--                                    :labelCol="labelCol"-->
          <!--                                    :wrapperCol="wrapperCol"-->
          <!--                                    label="是否开启多组裁判"-->
          <!--                                    hasFeedback-->
          <!--                            >-->
          <!--                                <a-switch v-model="caipanChecked" checked-children="开启" un-checked-children="关闭"-->
          <!--                                          @click="onCaipanChange"/>-->
          <!--                            </a-form-item>-->
          <!--                        </a-col>-->
          <!--                        <a-col :md="12" :sm="24" v-if="caipanChecked">-->
          <!--                            <a-form-item-->
          <!--                                    :labelCol="labelCol"-->
          <!--                                    :wrapperCol="wrapperCol"-->
          <!--                                    label="裁判组别优先"-->
          <!--                                    hasFeedback-->
          <!--                            >-->
          <!--                                <a-switch v-model="caipanChoiceChecked" checked-children="A组优先"-->
          <!--                                          un-checked-children="B组优先" @change="onCaipanChoiceChange"/>-->
          <!--                            </a-form-item>-->
          <!--                        </a-col>-->
          <!--                    </a-row>-->
          <a-table :columns="timeColumns" :dataSource="mingdanSelectedList" :pagination="false" rowKey="id"
                   :row-selection="{ selectedRowKeys: selectedTimeRowKeys, onChange: onTimeSelectChange }"
                   bordered>
                        <span slot="mingcheng" slot-scope="name,record,index">
                             {{ index + 1 }}# {{ record.mingcheng }}  <br/>
                               <span style="color:#999">{{ record.subject_name }}</span><br/>
                          运动员:  <span style="color:#999">{{ record.yundongyuans }}</span>
                            </span>
            </span>
            <span slot="caipan_a" slot-scope="name,record,index">
                            <div style="text-align: center;">

                                <a-icon type="right-square" theme="twoTone" two-tone-color="#52c41a"
                                        v-if="record.jgroup == 0" @click="onSubjectCaipanRowSet(record)"
                                        style="font-size: 32px;"/>
                            </div>
                        </span>
            <span slot="caipan_b" slot-scope="name,record,index">
                            <div style="text-align: center;">

                                <a-icon type="left-square" theme="twoTone" two-tone-color="#52c41a"
                                        v-if="record.jgroup == 1" @click="onSubjectCaipanRowSet(record)"
                                        style="font-size: 32px;"/>
                            </div>
                        </span>

            <span slot="check_time" slot-scope="text,record,index">
                            <a-time-picker :default-open-value="moment(record.check_time, 'HH:mm:ss')"
                                           :value="moment(record.check_time, 'HH:mm:ss')"
                                           @openChange="onSubjectRowChange(index, 'check_time')"
                                           @change="onSubjectTimeChange"/>
                        </span>
            <span slot="check_time2" slot-scope="text,record,index">
                            <a-time-picker :default-open-value="moment(record.check_time2, 'HH:mm:ss')"
                                           :value="moment(record.check_time2, 'HH:mm:ss')"
                                           @openChange="onSubjectRowChange(index, 'check_time2')"
                                           @change="onSubjectTimeChange"/>
                        </span>
            <span slot="check_time3" slot-scope="text,record,index">
                            <a-time-picker :default-open-value="moment(record.check_time3, 'HH:mm:ss')"
                                           :value="moment(record.check_time3, 'HH:mm:ss')"
                                           @openChange="onSubjectRowChange(index, 'check_time3')"
                                           @change="onSubjectTimeChange"/>
                        </span>
            <span slot="sai_time" slot-scope="text,record,index">
                            <a-time-picker :default-open-value="moment(record.sai_time, 'HH:mm:ss')"
                                           :value="moment(record.sai_time, 'HH:mm:ss')"
                                           @openChange="onSubjectRowChange(index, 'sai_time')"
                                           @change="onSubjectTimeChange"/>
                        </span>
          </a-table>
        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleTimeCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleTimeOk">保存</a-button>
      </template>
    </a-modal>
    <a-modal
        :maskClosable="false"
        title="音乐下载"
        :width="1200"
        :centered="true"
        :bodyStyle="{maxHeight:'600px','overflowY':'scroll'}"
        v-model="musicVisible"
        @cancel="musicVisible = false"

    >
      <a-spin :spinning="musicSaveLoading">
        <a-form :form="form">
          <a-table :columns="musicColumns" :dataSource="mingdanSelectedList" :pagination="false" rowKey="id"
                   bordered>

            <!--                        <a-table :columns="musicColumns" :dataSource="mingdanSelectedList" :pagination="false" rowKey="id"-->
            <!--                                 :rowSelection="{ selectedRowKeys: selectedMusicRowKeys, onChange: onMusicSelectChange }"-->
            <!--                                 bordered>-->
            <span slot="mingcheng" slot-scope="name,record,index">
                             {{ index + 1 }}# {{ record.mingcheng }}  <br/>
                               <span style="color:#999">{{ record.subject_name }}</span><br/>
                          运动员:  <span style="color:#999">{{ record.yundongyuans }}</span>
                            </span>
            <span slot="download" slot-scope="text,record,index">
                            <a-button type="link"
                                      @click="onDownload(record)">
                              {{ record.subject_music_url }}
                            </a-button>
                        </span>
          </a-table>
        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="createAll" @click="downloadAllShow = true">批量下载音乐</a-button>
        <a-button key="cancel" @click="musicVisible = false">取消</a-button>
        <a-button key="forward" type="primary" @click="musicVisible = false">确定</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
        title="裁判设置"
        :width="1000"
        style="top: 20px;"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="userVisible"
        @ok="userVisible=false"
    >
      <a-spin :spinning="caipanSaveLoading">
        <a-form :form="form">
          <a-row>
            <a-col :span="12">
              <a-form-item
                  :labelCol="labelColLeader"
                  :wrapperCol="wrapperColLeader"
                  label="裁判长"
                  hasFeedback
              >
                            <span v-for="(user,index) in caipanLeaderList" :key="index">
                                    <a-tag>{{ user.name }} {{ user.num }} ({{ user.type }})</a-tag>
                                    <a-popconfirm
                                        title="确定删除此人员吗"
                                        @confirm="deleteUser(user)"
                                        okText="确定"
                                        cancelText="取消"
                                    >
                                        <a-icon type="close-circle"/>
                                    </a-popconfirm>
                            </span>
                <div>
                  <a href="javascript:;" v-show="!caipanLeaderShow"
                     @click="handleScoreUserExtraAdd('裁判长')">设置</a>
                  <caipan-picker
                      v-if="caipanLeaderShow"
                      style="width: 180px; margin-right: 10px;"
                      @onSelect="onCaipanAdd"/>
                  <a href="javascript:;" v-show="caipanLeaderShow"
                     @click="caipanLeaderShow = false">取消</a>
                </div>
              </a-form-item>

            </a-col>
            <a-col :span="12">

              <a-form-item
                  :labelCol="labelColLeader"
                  :wrapperCol="wrapperColLeader"
                  label="副裁判长"
                  hasFeedback
              >
                            <span v-for="(user,index) in caipanLeaderViceList" :key="index">
                                    <a-tag>{{ user.name }} {{ user.num }} ({{ user.type }})</a-tag>
                                    <a-popconfirm
                                        title="确定删除此人员吗"
                                        @confirm="deleteUser(user)"
                                        okText="确定"
                                        cancelText="取消"
                                    >
                                        <a-icon type="close-circle"/>
                                    </a-popconfirm>
                            </span>
                <div>
                  <a href="javascript:;" v-show="!caipanLeaderViceShow"
                     @click="handleScoreUserExtraAdd('副裁判长')">设置</a>
                  <caipan-picker
                      v-if="caipanLeaderViceShow"
                      style="width: 180px; margin-right: 10px;"
                      @onSelect="onCaipanAdd"/>
                  <a href="javascript:;" v-show="caipanLeaderViceShow"
                     @click="caipanLeaderViceShow = false">取消</a>
                </div>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">

              <a-form-item
                  :labelCol="labelColLeader"
                  :wrapperCol="wrapperColLeader"
                  label="仲裁主任"
                  hasFeedback
              >
                            <span v-for="(user,index) in caipanArbTorList" :key="index">
                                    <a-tag>{{ user.name }} {{ user.num }} ({{ user.type }})</a-tag>
                                    <a-popconfirm
                                        title="确定删除此人员吗"
                                        @confirm="deleteUser(user)"
                                        okText="确定"
                                        cancelText="取消"
                                    >
                                        <a-icon type="close-circle"/>
                                    </a-popconfirm>
                            </span>
                <div>
                  <a href="javascript:;" v-show="!caipanArbTorShow"
                     @click="handleScoreUserExtraAdd('仲裁主任')">设置</a>
                  <!--                  换成输入-->
                                   <caipan-picker
                                       v-if="caipanArbTorShow"
                                       style="width: 180px; margin-right: 10px;"
                                      @onSelect="onCaipanAdd"/>

                  <!-- <div class="flex-start"  v-show="caipanArbTorShow">
                    <a-input v-model="caipanInputName" placeholder="请输入姓名" style="width: 200px"/>
                    <a href="javascript:;" @click="onZhongcaiAdd" style="margin-left: 10px">新增</a>
                    <a href="javascript:;"
                       @click="caipanArbTorShow = false" style="margin-left: 10px">取消</a>
                  </div> -->

                </div>
              </a-form-item>

            </a-col>
            <a-col :span="12">

              <a-form-item
                  :labelCol="labelColLeader"
                  :wrapperCol="wrapperColLeader"
                  label="仲裁委员"
                  hasFeedback
              >
                            <span v-for="(user,index) in caipanArbList" :key="index">
                                    <a-tag>{{ user.name }} {{ user.num }} ({{ user.type }})</a-tag>
                                    <a-popconfirm
                                        title="确定删除此人员吗"
                                        @confirm="deleteUser(user)"
                                        okText="确定"
                                        cancelText="取消"
                                    >
                                        <a-icon type="close-circle"/>
                                    </a-popconfirm>
                            </span>
                <div>
                  <a href="javascript:;" v-show="!caipanArbShow"
                     @click="handleScoreUserExtraAdd('仲裁委员')">设置</a>
                 <caipan-picker
                     v-if="caipanArbShow"
                     style="width: 180px; margin-right: 10px;"
                   @onSelect="onCaipanAdd"/>
                  <!-- <div class="flex-start"  v-show="caipanArbShow">
                    <a-input v-model="caipanInputName" placeholder="请输入姓名" style="width: 200px"/>
                    <a href="javascript:;" @click="onZhongcaiAdd" style="margin-left: 10px">新增</a>
                    <a href="javascript:;"
                       @click="caipanArbShow = false" style="margin-left: 10px">取消</a>
                  </div> -->
                </div>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">

              <a-form-item
                  :labelCol="labelColLeader"
                  :wrapperCol="wrapperColLeader"
                  label="技术监督"
                  hasFeedback
              >
                            <span v-for="(user,index) in caipanTecList" :key="index">
                                    <a-tag>{{ user.name }} {{ user.num }} ({{ user.type }})</a-tag>
                                    <a-popconfirm
                                        title="确定删除此人员吗"
                                        @confirm="deleteUser(user)"
                                        okText="确定"
                                        cancelText="取消"
                                    >
                                        <a-icon type="close-circle"/>
                                    </a-popconfirm>
                            </span>
                <div>
                  <a href="javascript:;" v-show="!caipanTecShow"
                     @click="handleScoreUserExtraAdd('技术监督')">设置</a>
                  <caipan-picker
                      v-if="caipanTecShow"
                      style="width: 180px; margin-right: 10px;"
                      @onSelect="onCaipanAdd"/>
                  <a href="javascript:;" v-show="caipanTecShow"
                     @click="caipanTecShow = false">取消</a>
                </div>
              </a-form-item>

            </a-col>

            <a-col :span="12">

              <a-form-item
                  :labelCol="labelColLeader"
                  :wrapperCol="wrapperColLeader"
                  label="不打分裁判"
                  hasFeedback
              >
                            <span v-for="(user,index) in caipanNoteList" :key="index">
                                    <a-tag>{{ user.name }} {{ user.num }} ({{ user.type }})</a-tag>
                                    <a-popconfirm
                                        title="确定删除此人员吗"
                                        @confirm="deleteUser(user)"
                                        okText="确定"
                                        cancelText="取消"
                                    >
                                        <a-icon type="close-circle"/>
                                    </a-popconfirm>
                            </span>
                <div>
                  <a href="javascript:;" v-show="!caipanNoteShow"
                     @click="handleScoreUserExtraAdd('记录裁判')">设置</a>
                  <caipan-picker
                      v-if="caipanNoteShow"
                      style="width: 180px; margin-right: 10px;"
                      @onSelect="onCaipanAdd"/>
                  <a href="javascript:;" v-show="caipanNoteShow"
                     @click="caipanNoteShow = false">取消</a>
                </div>
              </a-form-item>

<!--              <a-form-item-->
<!--                  :labelCol="labelColLeader"-->
<!--                  :wrapperCol="wrapperColLeader"-->
<!--                  label="不打分裁判"-->
<!--                  hasFeedback-->
<!--              >-->
<!--                            <span v-for="(user,index) in caipanNoteList" :key="index">-->
<!--                                    <a-tag>{{ user.name }} {{ user.num }} ({{ user.type }})</a-tag>-->
<!--                                    <a-popconfirm-->
<!--                                        title="确定删除此人员吗"-->
<!--                                        @confirm="deleteUser(user)"-->
<!--                                        okText="确定"-->
<!--                                        cancelText="取消"-->
<!--                                    >-->
<!--                                        <a-icon type="close-circle"/>-->
<!--                                    </a-popconfirm>-->
<!--                            </span>-->
<!--                <div>-->
<!--                  <a href="javascript:;" v-show="!caipanNoteShow"-->
<!--                     @click="handleScoreUserExtraAdd('记录裁判')">设置</a>-->
<!--                  &lt;!&ndash;                  <caipan-picker&ndash;&gt;-->
<!--                  &lt;!&ndash;                      v-if="caipanArbShow"&ndash;&gt;-->
<!--                  &lt;!&ndash;                      style="width: 180px; margin-right: 10px;"&ndash;&gt;-->
<!--                  &lt;!&ndash;                      @onSelect="onCaipanAdd"/>&ndash;&gt;-->
<!--                  <div class="flex-start"  v-show="caipanNoteShow">-->
<!--                    <a-input v-model="caipanInputName" placeholder="请输入姓名" style="width: 200px"/>-->
<!--                    <a href="javascript:;" @click="onZhongcaiAdd" style="margin-left: 10px">新增</a>-->
<!--                    <a href="javascript:;"-->
<!--                       @click="caipanNoteShow = false" style="margin-left: 10px">取消</a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </a-form-item>-->


            </a-col>
          </a-row>

          <a-divider>A组裁判</a-divider>
          <a-row>
            <a-col :span="12" v-for="(user,index) in scoreUserAList" :key="index"
                   style="margin-bottom: 10px;height: 25px;line-height: 25px">
              <div v-if="user.num">

                <span>{{ '裁判' + (index + 1) }}：</span>
                <a-tag>{{ user.name }} {{ user.num }} ({{ user.is_new==2?'非新周期':'' }}{{ user.type }})</a-tag>
                <a-popconfirm
                    title="确定删除此人员吗"
                    @confirm="deleteUser(user,index)"
                    okText="确定"
                    cancelText="取消"
                >
                  <a-icon type="close-circle"/>
                </a-popconfirm>
              </div>

              <div v-else>
                <span>{{ '裁判' + (index + 1) }}：</span>
                <span v-if="user.show">
                                     <caipan-picker
                                         style="width: 180px; margin-right: 10px;"
                                         @onSelect="onCaipanAAdd"
                                     />
                                    <a href="javascript:;" @click="user.show = false">取消</a>
                                </span>

                <a href="javascript:;" v-else @click="handleScoreUserAdd(user, index)">设置</a>
              </div>

            </a-col>
          </a-row>


          <a-divider v-if="caipanTypeNum > 1">B组裁判</a-divider>
          <a-row v-if="caipanTypeNum > 1">
            <a-col :span="12" v-for="(user,index) in scoreUserBList" :key="index"
                   style="margin-bottom: 10px;height: 25px;line-height: 25px">
              <div v-if="user.num">
                <span>{{ '裁判' + (index + 1) }}：</span>
                <a-tag>{{ user.name }} {{ user.num }} ({{ user.is_new==2?'非新周期':'' }}{{ user.type }})</a-tag>
                <a-popconfirm
                    title="确定删除此人员吗"
                    @confirm="deleteUser(user,index)"
                    okText="确定"
                    cancelText="取消"
                >
                  <a-icon type="close-circle"/>
                </a-popconfirm>
              </div>

              <div v-else>
                {{ '裁判' + (index + 1) }}：
                <a href="javascript:;" v-if="!user.show"
                   @click="handleScoreUserAdd(user, index)">设置</a>

                <caipan-picker
                    style="width: 180px; margin-right: 10px;"
                    @onSelect="onCaipanBAdd"
                    v-show="user.show"
                    field="user_id"
                />
                <a href="javascript:;" v-if="user.show" @click="user.show = false">取消</a>
              </div>
            </a-col>
          </a-row>

        <a-button key="cancel" @click="downloadCaipan(userFormData.start_id)">下载</a-button>
        <a-button style="margin-left:10px" key="cancel" @click="downloadCaipanSaiqu(userFormData.saiqu)">按赛区下载</a-button>
        </a-form>
      </a-spin>
    </a-modal>

    <a-modal
        :maskClosable="false"
        :footer="null"
        title="批量下载"
        v-model="downloadAllShow"
    >
      <p v-show="taskInfo.doing">正在批量下载音乐,请勿关闭或者刷新页面 <br/>
        <a-badge status="success" :text="'成功 '+(taskInfo.scount)"/>
        <a-divider type="vertical"/>
        <a-badge status="error" :text="'失败 '+(taskInfo.fcount)"/>
        <a-divider type="vertical"/>
        <a-badge status="processing" :text="'总数 '+(taskInfo.urls.length-1) "/>
      </p>
      <p v-show="!taskInfo.doing && musicUrlDownload">
        <a @click="createAllCert()">重新生成</a>
        <a-divider type="vertical"/>
        <a @click="downloadMusicMp()">批量下载</a>
      </p>
      <p v-show="!taskInfo.doing && !musicUrlDownload">
        <a @click="createAllCert()">批量下载</a>
      </p>
      <p>
        <a-progress v-show="taskInfo.doing" :percent="taskInfo.percent"/>
      </p>
    </a-modal>
  </a-card>
</template>

<style scoped>

.custom-item1, .custom-item2 {
  width: 50%;
}

.subject-box {
  display: flex;
  justify-content: start;
}

.subject-box >>> td {
  padding: 6px !important;
  width: auto !important;
  min-width: auto !important;
}

.subject-box >>> .ant-table-thead {
  display: none !important;
}

.subject-row-one {
  /*width: 50%;*/
}

.subject-row-header {
  border-bottom: 1px solid rgb(232, 232, 232);
  padding: 6px 12px;
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
}

.subject-two-header {
  border-bottom: 1px solid rgb(232, 232, 232);
  padding: 6px 12px;
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
}

.subject-header {
  border-bottom: 1px solid rgb(232, 232, 232);
  padding: 6px 12px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subject-content {
  height: 466px;
  overflow: auto;
  list-style: none;
}

.subject-li {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 6px 12px;
  min-height: 32px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  border-bottom: 1px solid rgb(232, 232, 232);
}

.subject-button {
  width: 10%;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: -webkit-flex;
}

.button-detail button {
  margin-bottom: 5px;
}

.subject-right {
  display: flex;
  justify-content: start;
}

.subject-left, .subject-right {
  width: 45%;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  height: 500px;
  position: relative;
}

.subject-with-header {
  padding-top: 34px;
}

.ant-transfer .ant-transfer-list:first-child .footer-btn {
  display: none
}

.subject-transfer /deep/ .is-visible {
  height: auto !important;
  border-bottom: 1px solid #eee
}

.ant-transfer >>> .ant-transfer-list:first-child ul.ant-transfer-list-content {
  counter-reset: none;
}

.ant-transfer >>> .ant-transfer-list:first-child ul.ant-transfer-list-content div.LazyLoad {
  padding-left: inherit;
}

.ant-transfer >>> .ant-transfer-list:first-child ul.ant-transfer-list-content div.LazyLoad:before {
  content: '';
  display: block;
}

.ant-transfer >>> ul.ant-transfer-list-content {
  counter-reset: show-list;
}


.ant-transfer >>> .ant-checkbox-wrapper-checked + span div{
  background: #faad14;
} 

.subject-box >>> .ant-table-row-selected td .diuiwuitem{
  background: #faad14 !important;
}

.subject-box >>> .ant-table-row-selected td .beixuandiv
{
  background: #faad14 !important;
}


.ant-transfer >>> ul.ant-transfer-list-content div.LazyLoad {
  padding-left: 30px;
  position: relative;
  counter-increment: item;
}

.ant-transfer >>> ul.ant-transfer-list-content div.LazyLoad:before {
  content: counter(item) ".";
  display: block;
  position: absolute;
  left: 12px;
  top: 0;
}

.subject-transfer /deep/ .is-visible {
  height: auto !important;
  border-bottom: 1px solid #eee
}
</style>
<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import areaOptions from '@/utils/area'
import moment from 'moment'
import setting from '@/config/setting'
import CaipanPicker from '@/components/CaipanPicker/'
import TreeNode from "@/components/TreeNode.vue";

import jquery from 'jquery'

import 'moment/locale/zh-cn';
import OSS from 'ali-oss';

moment.locale('zh-cn');

import {
  startListOptions,
  startListForMakeOptions,
  getStartList,
  startListSave,
  startListTimeSave,
  getScoreUserList,
  addScoreUser,
  deleteScoreUser,
  setStatus,
  setShow,
  startListDelete,
  getAllMusicUrls,
} from '@/api/dscore'

import {doUrlTask} from '@/api/utils'
import qs from 'qs'
import {sjsqOptions, subjectOptions} from '@/api/sai'

export default {
  name: 'ScoreStartList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    EditableCell,
    CaipanPicker, 
    TreeNode,
  },
  data() {
    return {
      treeData: [  
        {  
          id: 1,  
          label: 'Root',  
          children: [  
            { id: 2, label: 'Child 1', children: [
              { id: 4, label: 'Grandchild 1.1', children: [
                { id: 44, label: 'Grandchild 1.1.1', children: [] },
                { id: 45, label: 'Grandchild 1.1.2', children: [] }, 
                
                ] },
              { id: 5, label: 'Grandchild 1.2', children: [
                { id: 46, label: 'Grandchild 1.1.1', children: [] },
                { id: 47, label: 'Grandchild 1.1.2', children: [] }, 
                
              ] },
              
              ] 
              },  
            { id: 3, label: 'Child 2', children: [
              { id: 5, label: ' 2.1', children: [

                { id: 48, label: ' 2.1.1', children: [] },
                { id: 49, label: ' 2.1.2', children: [] }, 
              ] },
              { id: 51, label: ' 2.2', children: [
                { id: 411, label: ' 2.2.1', children: [] },
                { id: 412, label: ' 2.2.2', children: [] }, ] },
              
              ] }  
          ]  
        }  
      ],  
      // SVG画布大小  
      width: 1100,
      height: 1000 ,

      areaOptions,
      gxSaveShow:false,
      gxSaveFlag:false,
      visible: false,
      visibleMore: false,
      saveLoading: false,
      chuchangSaveLoading: false,
      timeSaveLoading: false,
      musicSaveLoading: false,
      caipanSaveLoading: false,
      downloadAllShow: false,
      saiqu: 0,
      mingdanList: [],
      mingdanSelectedList: [],

      mingdanOldLeftList: [],
      mingdanLeftList: [],
      mingdanRightList: [],
      subjectKeywords: '',

      sjsqOptions: [],
      subjectOptions: [],
      mingdanTargetKeys: [],
      selectedMingdanKeys: [],
      scoreUserList: [],
      scoreUserAList: [], //裁判A
      scoreUserBList: [], //裁判B

      userVisible: false,
      timeVisible: false, // 时间弹出层控制
      musicVisible: false, // 音乐弹出层控制
      userPickerVisible: false, // 裁判用户选择器

      caipanChecked: false,
      caipanLeaderShow: false,
      caipanLeaderViceShow: false,
      caipanArbShow: false,
      caipanArbTorShow: false,
      caipanTecShow: false,
      caipanNoteShow: false,
      caipanLeaderList: [], //裁判长
      caipanLeaderViceList: [], // 副裁判长
      caipanArbList: [], //仲裁委员
      caipanArbTorList: [], //仲裁主任
      caipanTecList: [], //技术监督
      caipanNoteList: [], //记录裁判
      caipanLeader: {
        id: 0,
        show: false,
      }, //裁判长
      caipanTime: {
        id: 0,
        show: false,
      }, //时间裁判
      caipanTypeNum: 0,
      scoreUserIndex: 0, //选择的裁判index
      defaultCaipanList: [
        {index: 0, show: false},
        {index: 1, show: false},
        {index: 2, show: false},
        {index: 3, show: false},
        {index: 4, show: false},
        {index: 5, show: false},
        {index: 6, show: false},
        {index: 7, show: false},
        {index: 8, show: false},
        {index: 9, show: false},
      ], //默认裁判数量
      defaultCaipanBList: [
        {index: 0, show: false},
        {index: 1, show: false},
        {index: 2, show: false},
        {index: 3, show: false},
        {index: 4, show: false},
        {index: 5, show: false},
        {index: 6, show: false},
        {index: 7, show: false},
        {index: 8, show: false},
        {index: 9, show: false},
      ], //默认裁判数量

      caipanChoiceChecked: true,
      subjectIndex: 0, // 修改时间的项目序号
      subjectName: 0, // 修改时间的项目名称
      ossAccessTokenURL: 'https://api.ccachina.net/core/attachment/aliOssSts',

      userFormData: {
        user_id: undefined,
        type: undefined,
        name: undefined,
        start_id: 0,
      },

      caipanInputName: '', //仲裁输入的裁判名称

      formData: {
        id: 0,
        type:1,
        is_more_caipan: false
      },

      taskInfo: {
        urls: [],
        currentIndex: 0,
        scount: 0,
        fcount: 0,
        percent: 0,
        doing: false,
      },
      start_id: 0,
      musicUrlDownload: '',

      saiTimeTotal: '00:00:00',
      timeData: {
        checkTime1: '00:00:00',
        checkTime2: '00:00:00',
        checkTime3: '00:00:00',
        timeSpan: '',
        timeSpanOld: 0,
        saiTime: '00:00:00',
      },
      time_range_moment: [],
      time_range: [],
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      labelColLeader: {
        xs: {span: 24},
        sm: {span: 4},
      },
      wrapperColLeader: {
        xs: {span: 24},
        sm: {span: 16},
      },
      labelColNew: {
        xs: {span: 24},
        sm: {span: 10},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '场次信息',
          dataIndex: 'title',
          scopedSlots: {customRender: 'title1'},
        },
        {
          title: '赛区',
          dataIndex: 'saiqu',
          scopedSlots: {
            customRender: 'saiqu' +
                ''
          },
        },
        {
          title: '进度',
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 265,
          scopedSlots: {customRender: 'action'},
        }
      ],

      // 音乐下载表头
      musicColumns: [
        {
          title: '队伍信息',
          dataIndex: 'mingcheng',
          scopedSlots: {customRender: 'mingcheng'},
          width: 600,
        },
        {
          title: '下载地址',
          dataIndex: 'download',
          scopedSlots: {customRender: 'download'},
        },
      ],

      //人员管理表头
      userColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '用户名',
          dataIndex: 'name',
          scopedSlots: {customRender: 'name'}
        },
        {
          title: '角色',
          width: '100px',
          dataIndex: 'type'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: {customRender: 'action'}
        }
      ],

      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getStartList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      subjectFilterValue: '',

      selectedRowKeys: [],
      selectedRows: [],
      selectedMusicRowKeys: [],
      selectedMusicRows: [],
      selectedTimeRowKeys: [],
      selectedTimeRows: [],

      // 多组裁判穿梭框
      subjectLeftSelectedKeys: [],
      subjectRightSelectedKeys: [],
      indeterminate: false,
      indeterminateA: false, // 右侧A组裁判
      indeterminateB: false, // 右侧B组裁判
      checkAll: false,
      checkAllA: false,
      checkAllB: false,

      testColumns: [
        {
          title: '',
          dataIndex: 'name',
          scopedSlots: {customRender: 'name'},
        },
      ],

      testColumns2: [
        {
          title: '',
          align: 'left',
          dataIndex: 'name1',
          scopedSlots: {customRender: 'name1'},

        },
        {
          title: '',
          align: 'right',
          dataIndex: 'name2',
          scopedSlots: {customRender: 'name2'},
        },
      ],

      testData: []
    }
  },
  created() {
  },
  mounted() {
    let that = this;
    console.log(1111)
    that.getSjsqOptions();
            
 
    // console.log()

  },
  computed: {
    timeColumns() {
      let that = this;
      let columns = [
        {
          title: '队伍信息',
          dataIndex: 'mingcheng',
          scopedSlots: {customRender: 'mingcheng'},
          width: 300,
        },
      ];

      // if (that.caipanChecked) {
      //     columns.push(
      //         {
      //             width: 80,
      //             title: 'A组',
      //             dataIndex: 'caipan_a',
      //             scopedSlots: {customRender: 'caipan_a'},
      //         },
      //         {
      //             width: 80,
      //             title: 'B组',
      //             dataIndex: 'caipan_b',
      //             scopedSlots: {customRender: 'caipan_b'},
      //         }
      //     );
      // }

      columns.push(
          {
            width: 100,
            title: '检录时间一',
            dataIndex: 'check_time',
            scopedSlots: {customRender: 'check_time'},
          });
      columns.push(
          {
            width: 100,
            title: '检录时间二',
            dataIndex: 'check_time2',
            scopedSlots: {customRender: 'check_time2'},
          });
      columns.push(
          {
            width: 100,
            title: '检录时间三',
            dataIndex: 'check_time3',
            scopedSlots: {customRender: 'check_time3'},
          });
      columns.push(
          {
            width: 100,
            title: '比赛时间',
            dataIndex: 'sai_time',
            scopedSlots: {customRender: 'sai_time'},
          });

      return columns;

    },

    customerMingdanRightList() {
      /**
       * 选择到A、B
       * 取消
       * 上移
       * 下移
       *
       * 定义leftList 和 rightList
       *
       * list:[
       *    {
       *        keyIndex: 0,
       *        jgroup: 0 || 1
       *    }
       * ]
       * mingdanTargetKeys 最后顺序的key列表
       *
       * 选中key 的顺序 AB穿插
       *
       * 1. 取出当前操作组别在右边选中的最后一个值的 序号
       * 2. 取出所有 邻近为空的list
       */
      const self = this,
          keys = self.mingdanTargetKeys

      let leftList = [],
          rightList = [] // 选中到右边的所有值


      if (keys.length === 0) {
        // 初始化 ==> 新增
        leftList = self.mingdanList
        for (var i = 0; i < 200; i++) {
          const rowData = {
            key: -1,
            keyIndex: -1,
            subject_name: '预设位置',
            jgroup: i % 2 === 0 ? 0 : 1
          }

          rightList.push(rowData)
        }
      } else {
        self.mingdanList.map(row => {
          if (keys.indexOf(row.key) === -1) {
            leftList.push(row)
          }
        })

        rightList = self.getRightList()
      }


      // 左边需要移除keys
      self.mingdanLeftList = self.mingdanOldLeftList = leftList
      self.mingdanRightList = rightList

      console.log('customerMingdanRightList', keys, leftList, rightList, self.mingdanList)

      self.formatRight()
      return rightList
    }

  },
  methods: {
    moment, 
    getSjsqOptions() {
      let that = this;
      sjsqOptions({}).then(res => {
        that.sjsqOptions = res.data;
      });
    },

    // 过滤左边值
    onSubjectChange(value) {
      let endValue = this.subjectFilterValue = value[value.length - 1],
          list = this.mingdanOldLeftList

      console.log('onSubjectChange', value, endValue, list)
      if (endValue) {
        this.mingdanLeftList = list.filter(function (row) {
          return row.subject.indexOf(endValue) > -1
        })
      } else {
        this.mingdanLeftList = list
      }
    },
    onSjsqChange(value) {
      let that = this;
      if (value.length == 2) {
        console.log(value);
        that.$refs.table.refresh(true)
      }
    },

    onSubjectNameFilter() {
      let word = this.subjectKeywords,
          list = this.mingdanOldLeftList

      this.mingdanLeftList = list.filter(function (row) {
        return (row.subject_name_s+' '+row.subject_name).indexOf(word) > -1
      })
    },

    onSubjectLeftSelectChange(selectedRowKeys, selectedRows) {
      this.subjectLeftSelectedKeys = selectedRowKeys
      // this.selectedTimeRows = selectedRows

      this.indeterminate = !!selectedRows.length && selectedRows.length < this.mingdanLeftList.length;
      this.checkAll = this.subjectLeftSelectedKeys.length === this.mingdanLeftList.length;
      console.log(selectedRowKeys, selectedRows)
    },

    onSubjectRightSelectChange(selectedRowKeys, selectedRows) {
      this.subjectRightSelectedKeys = selectedRowKeys
      this.selectedTimeRows = selectedRows
      let leftList = [],
          leftKeys = [],
          rightKeys = [],
          rightList = [],
          list = this.mingdanRightList

      list.map(row => {
        if (row.jgroup == 0) {
          if (selectedRowKeys.indexOf(row.key) > -1) {
            leftKeys.push(row.key)
          }
          leftList.push(row)
        } else {
          if (selectedRowKeys.indexOf(row.key) > -1) {
            rightKeys.push(row.key)
          }
          rightList.push(row)
        }
      })

      this.indeterminateA = !!leftKeys.length && leftKeys.length < leftList.length
      this.indeterminateB = !!rightKeys.length && rightKeys.length < rightList.length
      this.checkAllA = leftKeys.length > 0 && leftKeys.length === leftList.length
      this.checkAllB = rightKeys.length > 0 && rightKeys.length === rightList.length

      console.log(leftList, rightList, selectedRowKeys, leftKeys, rightKeys)

    },


    // 选择到A
    toSelectA() {
      let that = this
      // console.log(that.mingdanRightList)
      that.mingdanTargetKeys = that.mingdanTargetKeys.concat(that.subjectLeftSelectedKeys)
      that.mingdanList.map(row => {
        if (that.subjectLeftSelectedKeys.indexOf(row.key) > -1) {
          row.jgroup = 0
        }
      })
      that.formatMingdanList()
    },
    // 选择到B
    toSelectB() {
      let that = this
      // console.log(that.subjectLeftSelectedKeys)
      that.mingdanTargetKeys = that.mingdanTargetKeys.concat(that.subjectLeftSelectedKeys)
      that.mingdanList.map(row => {
        if (that.subjectLeftSelectedKeys.indexOf(row.key) > -1) {
          row.jgroup = 1
        }
      })
      that.formatMingdanList()
    },

    // 取消 到左边
    toSelectLeft() {
      // 如何留下空位 上移、下移 全选移动
      let that = this,
          rightKeys = that.subjectRightSelectedKeys,
          keys = []
      // that.mingdanTargetKeys = that.mingdanTargetKeys.filter(key => {
      //   return rightKeys.indexOf(key) === -1
      // })

      // subjectRightSelectedKeys增加 右边减少 targets

      // 留空 将key置为 -2
      that.mingdanRightList.map((row, keyIndex) => {
        if (rightKeys.indexOf(row.key) > -1) {
          that.mingdanRightList[keyIndex] = {
            key: -1,
            keyIndex: -1,
            subject_name: '留空位置',
            jgroup: row.jgroup
          }
        }
      })

      that.mingdanTargetKeys.map((key, keyIndex) => {
        if (rightKeys.indexOf(key) > -1) {
          that.mingdanTargetKeys.splice(keyIndex, 1)
        }
      })

      console.log(that.mingdanTargetKeys)

      that.formatMingdanList()

    },

    // 下移
    toSelectMoveDown() {
      let that = this
//        that.mingdanTargetKeys.pop();
      var list = [...that.mingdanRightList];
      that.subjectRightSelectedKeys.map(sitem => {
        that.mingdanRightList.map((titem, index) => {
          if (titem.key == sitem) {
            if (index == that.mingdanRightList.length - 1) {
              //最后个
              return;
            }
            var temp = list[index],
                num = that.getCommonGroupNum(sitem, 'down')
            if (!num) return
            console.log(num)

            list[index] = list[index + num];
            list[index + num] = temp;

          }
        })

      });

      that.mingdanRightList = [...list];
      that.formatMingdanList()

    },

    // 上移
    toSelectMoveUp() {
      let that = this
      // 操作targetKey jgroup同类型移动

      // 需要兼容同组别、空位的处理

      var list = [...that.mingdanRightList];
      that.subjectRightSelectedKeys.map(sitem => {
        that.mingdanRightList.map((titem, index) => {
          if (titem.key == sitem) {
            if (index == 0) {
              //第一个
              return
            }
            var temp = list[index],
                num = that.getCommonGroupNum(sitem)

            if (!num) return
            console.log(num)

            // 判断与上一个同组别的间隔 数量


            list[index] = list[index - num]
            list[index - num] = temp
          }
        })

      })

      that.mingdanRightList = [...list]

      // 直接操作list

      console.log(that.mingdanTargetKeys)
      that.formatMingdanList()
    },

    getCommonGroupNum(key, type = 'up') {
      /**
       * 1. 取出key对应的 row数据
       * 2. 取出row所在jgroup组的 index数组
       * 3. 获取间隔数量
       */

      let that = this,
          row = {},
          list = that.mingdanRightList,
          indexList = [],
          num = 0

      list.map((val, valIndex) => {
        if (val.key === key) {
          val.keyIndex = valIndex
          row = val
        }
      })

      list.map((val, valIndex) => {
        if (val.jgroup === row.jgroup) {
          indexList.push(valIndex)
        }
      })

      indexList.map((key, index) => {
        if (row.keyIndex === key && type === 'up') {
          if (index === 0) {
            num = 0
          } else {
            num = key - indexList[index - 1]
          }
        }

        if (row.keyIndex === key && type === 'down') {
          if (index === indexList.length) {
            num = 0
          } else {
            num = indexList[index + 1] - key
          }
        }
      })

      console.log("onMoveUpOne", row, indexList)
      return num

    },

    // 左边全选判断
    onCheckAllChange(e) {
      let keys = []
      this.mingdanLeftList.map(row => {
        keys.push(row.id)
      })
      Object.assign(this, {
        subjectLeftSelectedKeys: e.target.checked ? keys : [],
        indeterminate: false,
        checkAll: e.target.checked,
      })

      console.log(keys, this.selectedRowKeys)
    },

    // 右边A组全选判断
    onCheckAllAChange(e) {
      /**
       * 找出所有未选中的A组key
       * 拼接B组的key
       * 取消全选 从选中的keys中找出所有的B组key
       */

      let keys = [],
          rightBKeys = [],
          rightKeys = this.subjectRightSelectedKeys
      this.mingdanRightList.map(row => {
        if (row.jgroup === 0 && rightKeys.indexOf(row.key) === -1) {
          keys.push(row.id)
        } else if (!e.target.checked && row.jgroup === 1 && rightKeys.indexOf(row.key) > -1) {
          rightBKeys.push(row.id)
        }
      })
      keys = keys.concat(rightKeys)

      Object.assign(this, {
        subjectRightSelectedKeys: e.target.checked ? keys : rightBKeys,
        indeterminateA: false,
        checkAllA: e.target.checked,
      })

      console.log(keys, rightBKeys)
    },

    // 右边B组全选判断
    onCheckAllBChange(e) {
      let keys = [],
          rightAKeys = [],
          rightKeys = this.subjectRightSelectedKeys
      this.mingdanRightList.map(row => {
        if (row.jgroup === 1 && rightKeys.indexOf(row.key) === -1) {
          keys.push(row.id)
        } else if (!e.target.checked && row.jgroup === 0 && rightKeys.indexOf(row.key) > -1) {
          rightAKeys.push(row.id)
        }
      })

      keys = keys.concat(rightKeys)
      Object.assign(this, {
        subjectRightSelectedKeys: e.target.checked ? keys : rightAKeys,
        indeterminateB: false,
        checkAllB: e.target.checked,
      })

      console.log(keys, this.selectedRowKeys)
    },


    formatRight() {
      if (this.checkAllA) this.checkAllA = false
      if (this.checkAll) this.checkAll = false
      if (this.checkAllB) this.checkAllB = false

      this.subjectLeftSelectedKeys = []
      this.subjectRightSelectedKeys = []
      this.indeterminate = false
      this.indeterminateA = false
      this.indeterminateB = false
    },

    // 格式化 左右两组数据
    formatMingdanList() {
      /**
       * 选择到A、B
       * 取消
       * 上移
       * 下移
       *
       * 定义leftList 和 rightList
       *
       * list:[
       *    {
       *        keyIndex: 0,
       *        jgroup: 0 || 1
       *    }
       * ]
       * mingdanTargetKeys 最后顺序的key列表
       *
       * 选中key 的顺序 AB穿插
       *
       * 1. 取出当前操作组别在右边选中的最后一个值的 序号
       * 2. 取出所有 邻近为空的list
       */
      const self = this,
          keys = self.mingdanTargetKeys

      let leftList = [],
          rightList = [] // 选中到右边的所有值


      if (keys.length === 0) {
        // 初始化 ==> 新增
        leftList = self.mingdanList
        for (var i = 0; i < 200; i++) {
          const rowData = {
            key: -1,
            keyIndex: -1,
            subject_name: '预设位置',
            jgroup: i % 2 === 0 ? 0 : 1
          }

          rightList.push(rowData)
        }
      } else {
        self.mingdanList.map(row => {
          if (keys.indexOf(row.key) === -1) {
            leftList.push(row)
          }
        })

        rightList = self.getRightList()
      }


      // 左边需要移除keys
      // 有级联选择 左边需要再次筛选
      if (self.subjectFilterValue) {
        this.mingdanLeftList = leftList.filter(function (row) {
          return row.subject.indexOf(self.subjectFilterValue) > -1
        })
      } else {
        this.mingdanLeftList = leftList
      }
      self.mingdanOldLeftList = leftList
      self.mingdanRightList = rightList

      console.log('customerMingdanRightList', keys, leftList, rightList, self.mingdanList)

      self.chuchangSaveLoading = false
      self.formatRight()

    },

    getRightList() {
      const self = this,
          keys = self.mingdanTargetKeys,
          leftList = [],
          rightKeys = [],
          rightList = [] // 选中到右边的所有值

      // 保留取消 空置
      self.mingdanRightList.map(right => {
        rightKeys.push(right.key)
      })

      let keyData = self.distinct(rightKeys, keys)

      // 去除已经选择的list key
      // 需要根据keyData的排布顺序 取值
      keyData.map(key => {
        self.mingdanList.map(row => {
          if (key === row.key) {
            if (row.jgroup === 0) {
              leftList.push(row)
            } else {
              rightList.push(row)
            }
          }
        })
      })


      self.getReplaceRightList(0, leftList)
      self.getReplaceRightList(1, rightList)

      console.log(keyData, leftList, rightList, self.mingdanRightList)
      return self.mingdanRightList
    },

    getReplaceRightList(jgroup, rightList = []) {
      const usedKeys = [], // 已赋值的key
          self = this,
          endKey = self.getEndKey(jgroup)

      if (!rightList.length) return


      self.mingdanRightList.map((rowData, rowIndex) => {

        let judge = false
        rightList.map(right => {
          if (rowData.jgroup === jgroup && rowData.key >= -1 && rowIndex > endKey && usedKeys.indexOf(right.key) === -1) {
            if (!judge) {
              self.mingdanRightList[rowIndex] = right
              usedKeys.push(right.key)
              judge = true

              console.log(rowIndex)
            }
          }
          // console.log('usedKeys', usedKeys)
        })
      })

      console.log(self.mingdanRightList, endKey)

    },

    distinct(arr1, arr2) {
      return arr1.concat(arr2).filter(function (v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v);
      });
    },

    // 获取当前组别邻近 不为空的最后一个数 所在key值
    getEndKey(jgroup) {
      const self = this,
          rightGroupList = [],
          rightEmptyList = []

      // 如何穿插移动
      self.mingdanRightList.map((row, rowIndex) => {
        row.keyIndex = rowIndex
        if (row.jgroup === jgroup && row.key != -1) {
          rightGroupList[rowIndex] = row
        }

        if (row.jgroup === jgroup && row.key === -1) {
          rightEmptyList[rowIndex] = row
        }
      })

      // 当前组别 不为空的最后一个值
      const rightRow = rightGroupList[rightGroupList.length - 1]
      const endKey = rightRow ? rightRow.keyIndex : -1

      return endKey
    },

    getInitRightList() {
      const rightList = [],
          self = this
      for (var i = 0; i < 200; i++) {
        const rowData = {
          key: -1,
          keyIndex: -1,
          subject_name: '预设位置',
          jgroup: i % 2 === 0 ? 0 : 1
        }

        rightList.push(rowData)
      }
      self.mingdanRightList = rightList
    },

    mingdanUp() {
      let that = this;
      if (that.selectedMingdanKeys.length == 0) {
        return;
      }
      if (that.mingdanTargetKeys.length == 0) {
        return;
      }
      console.log(that.mingdanTargetKeys);
//        that.mingdanTargetKeys.pop();
      var list = [...that.mingdanTargetKeys];
      that.selectedMingdanKeys.map(sitem => {
        that.mingdanTargetKeys.map((titem, index) => {
          if (titem == sitem) {
            if (index == 0) {
              //第一个
              return;
            }
            var temp = list[index];
//              that.$set(this.mingdanTargetKeys,index,that.mingdanTargetKeys[index-1]);
//              that.$set(this.mingdanTargetKeys,index-1,temp);

            list[index] = list[index - 1];
            list[index - 1] = temp;

          }
        })

      });

      that.mingdanTargetKeys = [...list];
    },
    mingdanDown() {
      let that = this;

      if (that.selectedMingdanKeys.length == 0) {
        return;
      }
      if (that.mingdanTargetKeys.length == 0) {
        return;
      }
      console.log(that.mingdanTargetKeys);
//        that.mingdanTargetKeys.pop();
      var list = [...that.mingdanTargetKeys];
      that.selectedMingdanKeys.map(sitem => {
        that.mingdanTargetKeys.map((titem, index) => {
          if (titem == sitem) {
            if (index == that.mingdanTargetKeys.length - 1) {
              //最后个
              return;
            }
            var temp = list[index];
//              that.$set(this.mingdanTargetKeys,index,that.mingdanTargetKeys[index-1]);
//              that.$set(this.mingdanTargetKeys,index-1,temp);

            list[index] = list[index + 1];
            list[index + 1] = temp;

          }
        })

      });

      that.mingdanTargetKeys = [...list];
    },
    mingdanHandleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedMingdanKeys = [...targetSelectedKeys];
      console.log('sourceSelectedKeys: ', sourceSelectedKeys);
      console.log('targetSelectedKeys: ', targetSelectedKeys);
      jquery('.ant-checkbox-wrapper-checked').each(function(){
        // $(this).parent().addClass('checked');
        console.log(jquery(this).parent());
      })
      // console.log(jquery('.ant-checkbox-checked').parent());
    },
    mingdanFilterOption(inputValue, option) {
      return option.title.indexOf(inputValue) > -1;
    },
    mingdanHandleChange(targetKeys, direction, moveKeys) {
      console.log(targetKeys, direction, moveKeys);
      if (direction == 'right') {
        this.mingdanTargetKeys = this.mingdanTargetKeys.concat(moveKeys);
      } else {
        this.mingdanTargetKeys = this.mingdanTargetKeys.filter(function (Tkey) {
          return moveKeys.indexOf(Tkey) === -1;
        })
      }
    },

    mingdanHandleSearch(dir, value) {
      console.log('search:', dir, value);
    },

    fetchMingdanList(saiqu) {
      let self = this
      self.chuchangSaveLoading = true;
      self.getSubjectOptions(saiqu)
      console.log('formData.type',this.formData)
      startListForMakeOptions({
        'saiqu': saiqu,
        'id': self.formData.id,
        'type':self.formData.type,
      }).then(res => {
        self.mingdanList = res.data.list;

        self.mingdanTargetKeys = res.data.selectKeys.map(item => {
          return parseInt(item);
        })

        this.getInitRightList()
        this.formatMingdanList()

        // if (res.data.caipan_type_num == 2) {
        //   let leftKeys = [],
        //     rightKeys = []
        //   res.data.list.map(item => {
        //     self.mingdanTargetKeys.map(key => {
        //       if (key == item.key) {
        //         if (item.jgroup === 0) {
        //           leftKeys.push(item.key)
        //         } else {
        //           rightKeys.push(item.key)
        //         }
        //       }
        //
        //     })
        //
        //   });
        //
        //   console.log(leftKeys, rightKeys)
        //   setTimeout(function () {
        //     self.subjectLeftSelectedKeys = leftKeys
        //     self.formatMingdanList(0)
        //   }, 1)
        //   setTimeout(function () {
        //     self.subjectLeftSelectedKeys = rightKeys
        //     self.formatMingdanList(1)
        //   }, 2)
        // }

        // self.saiTimeTotal = res.data.sai_time_total ? res.data.sai_time_total : '00:00:00'
        // self.musicUrlDownload = res.data.music_zip

        self.formData.id = res.data.id;
        setTimeout(() =>{
          self.form.setFieldsValue({
            title:res.data.title
          })
        },300)
        self.formData = {...res.data};
        self.formData.saiqu = saiqu

        console.log("formData", self.formData)

        self.chuchangSaveLoading = false;
      })
    },

    // 获取设置出场顺序后的 项目队伍
    fetchMingdanSelectedList(saiqu) {
      let self = this
      self.getSubjectOptions(saiqu)
      startListOptions({
        'saiqu': saiqu,
        'id': self.formData.id,
      }).then(res => {
        self.mingdanTargetKeys = res.data.selectKeys.map(item => {
          return parseInt(item);
        });

        // 根据selectKeys 进行list排序
        let list = []
        res.data.selectKeys.map(item => {
          res.data.list.map(row => {
            if (row.key == parseInt(item)) {
              list.push(row)
            }
          });
        })
        self.mingdanSelectedList = list

        self.musicUrlDownload = res.data.music_zip

        // 判断是否为多组裁判
        self.caipanChecked = res.data.caipan_type_num > 1 ? true : false
        self.caipanTypeNum = res.data.caipan_type_num

        self.musicSaveLoading = false
        self.timeSaveLoading = false

        // 计算检录时间、时间间隔等信息
        if (self.mingdanSelectedList.length > 0) {
          let time = {},
              time2 = {},
              date = self.timeData
          self.mingdanSelectedList.map(row => {
            if (row.key == self.mingdanTargetKeys[0]) {
              time = row
            } else if (row.key == self.mingdanTargetKeys[1]) {
              time2 = row
            }
          })

          date.checkTime1 = time.check_time
          date.checkTime2 = time.check_time2
          date.checkTime3 = time.check_time3
          date.saiTime = time.sai_time
          date.timeSpan = date.timeSpanOld = (self.getTimeMinute(time2.check_time) - self.getTimeMinute(time.check_time)) / 60
        }
      })
    },

    getSubjectOptions(saiqu) {
      let that = this;
      subjectOptions({saiqu: saiqu}).then(res => {
        that.subjectOptions = res.data;
      });
    },

    downloadMusicMp() {
      window.open(setting.apiBaseURL + this.musicUrlDownload + '?_m=' + Math.random());
    },

    downloadSubject(record) {
      console.log('downloadSubject', record)
      let that = this,
          query = {
            saiqu: record.saiqu,
            start_id: record.id,

          }
      window.open(setting.apiBaseURL + '/adminapi/dscore/subjectListDownload?' + qs.stringify(query));
    },
    createAllCert() {
      let that = this;
      console.log("createAllCert")
      getAllMusicUrls({
        start_id: that.formData.id,
      }).then(res => {
        that.taskInfo = {
          urls: res.data,
          currentIndex: 0,
          scount: 0,
          fcount: 0,
          doing: true,
        }
        that.doTask(that.taskInfo);

      }).catch(err => {
        that.$message.error(err.data.msg);
      })
    },

    doTask(taskInfo) {
      let that = this;
      if (taskInfo.currentIndex >= taskInfo.urls.length) {
        taskInfo.doing = false;
        return false;
      }
      doUrlTask({
        url: taskInfo.urls[taskInfo.currentIndex]
      }).then(res => {
        taskInfo.scount++;
        taskInfo.currentIndex++;
        console.log(taskInfo.currentIndex);
        if (taskInfo.currentIndex == (taskInfo.urls.length)) {
          that.musicUrlDownload = res.data
        }
        taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.urls.length) * 100).toFixed(1);
        that.doTask(taskInfo)
      }).catch(err => {
        taskInfo.fcount++;
        taskInfo.currentIndex++;
        taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.urls.length) * 100).toFixed(1);
        that.doTask(taskInfo)
      });
    },

    renderItem(item) {
      let customLabel = '';
      if(item.score_total>0){
         customLabel = (
          <div  style="margin-top: -20px;" class="custom-item0" > 
            <span   xid="{{item.id}}">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {item.id} {item.mingcheng} <br/> <span style="color:#999">{item.subject_name_s}</span>
                  <br/>  <span style="color:#666">{item.saiqu_name}</span>
                  <br/> 运动员:<span style="color:#999">{item.yundongyuans}</span>
                  <br/><em>预赛成绩:<span style="color:#999">{item.score_total}</span> 排名:<span style="color:#999">{item.rank}</span></em>
                  </span>
                  </div>
        );
      }else{
         customLabel = (
          <div  style="margin-top: -20px;" class="custom-item0" > 
            <span   xid="{{item.id}}">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {item.id} {item.mingcheng} <br/> <span style="color:#999">{item.subject_name_s}</span>
                  <br/>  <span style="color:#666">{item.saiqu_name}</span>
                  <br/> 运动员:<span style="color:#999">{item.yundongyuans}</span>
                  </span>
                  </div>
        );
      }
      return {
        label: customLabel, // for displayed item
        value: item.title  +  item.subject_name, // for title and filter matching
      };
    },

    // 获取项目打开的 index 和修改的name值
    onSubjectRowChange(index, name) {
      console.log('onSubjectRowChange', index, name)
      let that = this
      that.subjectIndex = index
      that.subjectName = name
    },

    // 修改项目时间
    onSubjectTimeChange(time, timeString) {
      let that = this,
          list = that.mingdanSelectedList

      console.log(time, timeString)

      list[that.subjectIndex][that.subjectName] = timeString ? timeString : '00:00:00'

    },

    // 裁判长 弹框显示
    handleScoreUserExtraAdd(type) {
      let that = this

      that.userFormData.type = type
      that.userFormData.index = 0

      console.log('handleScoreUserExtraAdd', type)

      switch (type) {
        case '裁判长':
          that.caipanLeaderShow = true
          break
        case '副裁判长':
          that.caipanLeaderViceShow = true
          break
        case '仲裁主任':
          that.caipanArbTorShow = true
          break
        case '仲裁委员':
          that.caipanArbShow = true
          break
        case '技术监督':
          that.caipanTecShow = true
          break
        case '记录裁判':
          that.caipanNoteShow = true
          break
      }

    },

    onZhongcaiAdd() {
      // caipanInputName
      let that = this
      that.userFormData.user_id = 0
      that.userFormData.name = that.caipanInputName
      that.userFormData.num = ''
      that.userFormData.jgroup = 0
      that.addUser()
    },

    // 普通裁判 弹框显示
    handleScoreUserAdd(record, index) {
      let that = this
      record.show = true
      that.scoreUserIndex = index
      that.userFormData.index = index
    },

    onCaipanAdd(value) {
      let that = this
      that.userFormData.user_id = value.user_id
      that.userFormData.name = value.name
      that.userFormData.num = value.num
      that.userFormData.jgroup = 0
      that.addUser()
    },

    onCaipanAAdd(value) {
      console.log("onCaipanBAdd", value)
      let that = this
      that.userFormData.user_id = value.user_id
      that.userFormData.name = value.name
      that.userFormData.num = value.num
      that.userFormData.type = '裁判'

      that.userFormData.jgroup = 0
      that.addUser()
    },

    onCaipanBAdd(value) {
      console.log("onCaipanBAdd", value)
      let that = this
      that.userFormData.user_id = value.user_id
      that.userFormData.name = value.name
      that.userFormData.num = value.num
      that.userFormData.type = '裁判'
      that.userFormData.jgroup = 1
      that.addUser()
    },

    handleCancel() {
      this.visible = false
      this.gxSaveShow = false
      this.gxSaveFlag = false
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleAdd(type) {
      // console.log('handleAdd',type)
      if (typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length != 2) {
        this.$message.error('请先选择赛区');
        return;
      }
      this.visible = true
      this.formData.id = 0;
      this.formData.type= type; 

      this.fetchMingdanList(this.queryParam.sjsq[1]);
      // console.log(this.mdl)
    },

    handleMoreAdd(type) {
      if (typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length != 2) {
        this.$message.error('请先选择赛区');
        return;
      }
      this.visibleMore = true
      this.formData.type= type; 
      this.formData.id = 0;


      this.fetchMingdanList(this.queryParam.sjsq[1]);

      // console.log(this.mdl)
    },

    handleDownload() {
      if (typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length != 2) {
        this.$message.error('请先选择赛区');
        return;
      }

      let that = this,
          query = {
            sjsq: this.queryParam.sjsq
          }
      window.open(setting.apiBaseURL + '/adminapi/dscore/subjectListAllDownload?' + qs.stringify(query));
    },

    download(type){
      console.log('this.queryParam')
      console.log(this.queryParam)
      if(typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length !=2){
        this.$message.error('请先选择赛区');
        return ;
      }
      switch (type){
        case 1:
          window.open(setting.apiBaseURL+'/adminapi/sai/caipanDownload?saiqu='+this.queryParam.sjsq[1]);
          break;
        case 2:
          window.open(setting.apiBaseURL+'/adminapi/sai/lianxirenDownload?saiqu='+this.queryParam.sjsq[1]);
          break;
        case 3:
          window.open(setting.apiBaseURL+'/adminapi/sai/rysfzDownload?saiqu='+this.queryParam.sjsq[1]);
          break;
        case 4:
          window.open(setting.apiBaseURL+'/adminapi/sai/csrstjDownload?saiqu='+this.queryParam.sjsq[1]);
          break;
        case 5:
          window.open(setting.apiBaseURL+'/adminapi/sai/zhixuceDownload?saiqu='+this.queryParam.sjsq[1]+'&memberstatus='+(this.queryParam.memberstatus||0));
          break;
        case 6:
          window.open(setting.apiBaseURL+'/adminapi/sai/jiaofeiDownload?saiqu='+this.queryParam.sjsq[1]);
          break;
        case 7:
          // window.open(setting.apiBaseURL+'/adminapi/sai/jiaolianDownload?saiqu='+this.queryParam.sjsq[1]);
          window.open(setting.apiBaseURL + '/adminapi/dscore/scoreRewardDownload?saiqu='+this.queryParam.sjsq[1]);
          break;
      }
    },
    handleEdit(record) {
      let self = this

      // todo 判断是单组还是多组裁判

      console.log('handleEdit', record)
      if (record.caipan_type_num > 1) {
        this.visibleMore = true
      } else {
        this.visible = true
      }
      self.formData.id = record.id;
      self.formData.type = record.type;

      self.chuchangSaveLoading = true
      this.fetchMingdanList(record.saiqu);
      // console.log(this.mdl)
    },

    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

    // 增改 处理
    handleOk(e) {
      let that = this;
      // console.log('')
      // e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          let selectList = [];
          that.mingdanTargetKeys.map(key => {
            that.mingdanList.map(item => {
              if (item.key == key) {
                selectList.push(item);
                return;
              }
            })
          })

          if (selectList.length == 0) {
            that.$message.error('请至少选择一个项目');
            return
          }

          let  subjectDiv =that.subjectDivLimit(selectList);
          if(subjectDiv.length>0 && !that.gxSaveFlag){  
            let err_str = '';
            subjectDiv.map(errv =>{
              err_str+= '【'
              err_str+= errv.name +' 次序'+errv.index.join(',');
              err_str +="】"
            })
           // that.$message.error('以下同项被拆开了：'+err_str);
           // that.gxSaveShow= true;
           // return
          }
          that.gxSaveFlag = false
          that.gxSaveShow = false
          // return ;
          console.log(selectList);
          let limit8 = that.checkDev8Limit(selectList);
          if(limit8.length>0){ 
            let err_str = '';
            limit8.map(errv =>{
              err_str+= '【'
              err_str+= errv.name +' 次序'+errv.index.join(',');
              err_str +="】"
            })
            
            // that.$message.error('以下运动员间隔少于8：'+err_str);
            // return
          }
          // return ;
          console.log('that.formData', that.formData);
          // return ;
          that.saveLoading = true;
          startListSave({
            id: that.formData.id,
            title: values.title,
            saiqu: that.formData.saiqu,
            type: that.formData.type,
            sai_time: that.saiTimeTotal,
            list: JSON.stringify(selectList)
          }).then(res => {
            that.$message.success('保存成功');
            that.$refs.table.refresh()

            that.saveLoading = false;
          }).catch(err => {
            that.$message.error(err.data.msg);
            that.saveLoading = false;
          })
          this.visible = false;
        }
      })
    },

    handleMoreOk(e) {
      let that = this;
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          let selectList = [];

          that.mingdanRightList.map(row => {
            that.mingdanList.map(item => {
              if (item.key == row.key) {
                selectList.push(item);
                return;
              }
            })
          })


          if (selectList.length == 0) {
            that.$message.error('请至少选择一个项目');
            return
          }

          console.log(selectList);
          console.log('that.formData', that.formData);
      //  return ;
          startListSave({
            id: that.formData.id,
            title: values.title,
            saiqu: that.formData.saiqu,
            type: that.formData.type,
            sai_time: that.saiTimeTotal,
            list: JSON.stringify(selectList)
          }).then(res => {
            that.$message.success('保存成功');
            that.visibleMore = false;
            that.chuchangSaveLoading = false;

            that.$refs.table.refresh()
          }).catch(err => {
            that.$message.error(err.data.msg);
          })
        }
      })
    },

    handleMoreCancel() {
      this.visibleMore = false;
    },

    // 删
    startListDelete(record) {
      let self = this
      startListDelete({id: record.id}).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh(false)
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

    handleTimeOk(e) {
      let that = this,
          list = that.mingdanSelectedList

      console.log('handleTimeOk', list)

      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          if (list.length == 0) {
            that.$message.error('请至少选择一个项目');
            return
          }

          let count = 0

          // 对每个队伍的时间进行验证
          list.map(time => {
            let time1 = that.getTimeSecond(time.check_time),
                time2 = that.getTimeSecond(time.check_time2),
                time3 = that.getTimeSecond(time.check_time3),
                sai = that.getTimeSecond(time.sai_time)

            // console.log(time1, time2, time3, sai)

            if (!sai) {
              that.$message.error(time.mingcheng + '】未设置比赛时间')
              count++
              return
            }

            if (!time1) {
              that.$message.error(time.mingcheng + '】未设置检录时间一')
              count++
              return
            }

            if (time3 && sai <= time3) {
              console.log(sai, time3)
              that.$message.error(time.mingcheng + '】比赛时间不得小于或等于检录时间三')
              count++
              return
            } else if (time2 && sai <= time2) {
              that.$message.error(time.mingcheng + '】比赛时间不得小于或等于检录时间二')
              count++
              return
            } else if (time1 && sai <= time1) {
              console.log(sai, time1)
              that.$message.error(time.mingcheng + '】比赛时间不得小于或等于检录时间一')
              count++
              return
            }

            if (time3 && time2 && time3 <= time2) {
              that.$message.error(time.mingcheng + '】检录时间三不得小于或等于检录时间二')
              count++
              return
            } else if (time2 && time2 <= time1) {
              that.$message.error(time.mingcheng + '】检录时间二不得小于或等于检录时间一')
              count++
              return
            }
          })

          if (count) return

          startListTimeSave({
            id: that.formData.id,
            list: JSON.stringify(list)
          }).then(res => {
            that.$message.success('保存成功');
            that.$refs.table.refresh()
          }).catch(err => {
            that.$message.error(err.data.msg);
          })
          this.timeVisible = false;
        }
      })
    },

    // 下载音乐
    onDownload(record) {
      // window.open(url)
    window.open(record.subject_music_url);
      return ;
      let that = this,
          common = 'uploader/000/user-xxx/',
          data = record.subject_music_url.split('/')

      // console.log(data)
      let objectKey = common + data[data.length - 1];
      let saveAs = record.mingcheng + '.mp3';

      OSS.urllib.request(this.ossAccessTokenURL, {method: 'GET'}, function (err, response) {
        if (err) {
          return alert(err);
        }
        try {
          result = JSON.parse(response);
        } catch (e) {
          return alert('parse sts response info error: ' + e.message);
        }

        console.log(result)
        let client = new OSS({
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          // region表示您申请OSS服务所在的地域，例如oss-cn-hangzhou。
          region: 'oss-cn-hangzhou',
          bucket: result.data.bucket
        });
        let result = client.signatureUrl(objectKey, {
          expires: 3600,
          response: {
            'content-disposition': 'attachment; filename="' + saveAs + '"'
          }
        });
        console.log(result);
        window.open(result, '_blank')
//                     let result;
//                     try {
//                         result = JSON.parse(res);
//                     } catch (e) {
//                         return alert('parse sts response info error: ' + e.message);
//                     }
//
//                     console.log(result.data.AccessKeyId)
//                     var client = new OSS({
//                         region: "oss-cn-hangzhou",
//                         accessKeyId: result.data.AccessKeyId,
//                         accessKeySecret: result.data.AccessKeySecret,
//                         bucket: result.data.bucket
//                     });
//
//                     // 配置响应头实现通过URL访问时自动下载文件，并设置下载后的文件名。
//                     const filename = 'test1.js' // filename为自定义下载后的文件名。
//                     const response = {
//                         'content-disposition': `attachment; filename=${encodeURIComponent(filename)}`
//                     }
// // object-key表示从OSS下载文件时需要指定包含文件后缀在内的完整路径，例如abc/efg/123.jpg。
//                     const url = client.signatureUrl('abc/efg/123.mp3', { response });
//                     console.log(url);
      })
    },

    // 裁判设置
    handleUserManage(record) {
      let self = this
      self.userFormData.start_id = record.id
      self.userFormData.saiqu = record.saiqu
      self.caipanSaveLoading = true
      self.getScoreUserList()
      this.userVisible = true
    },

    handleDataOpen(record) {
      window.open('ScoreShow?saiqu='+record.saiqu +'&start_id=' +record.id);
    },

    // 时间设置
    handleTimeEdit(record) {
      let self = this
      this.timeVisible = true
      self.formData.id = record.id;
      self.timeSaveLoading = true
      this.fetchMingdanSelectedList(record.saiqu);
    },
    // 音乐下载
    handleMusicDownload(record) {
      let self = this
      self.formData.id = record.id
      self.musicSaveLoading = true
      self.fetchMingdanSelectedList(record.saiqu)
      this.musicVisible = true
    },

    handleTimeCancel() {
      let self = this;
      self.timeData = {
        checkTime1: '00:00:00',
        checkTime2: '00:00:00',
        checkTime3: '00:00:00',
        timeSpan: '',
        saiTime: '00:00:00',
      }

      self.timeVisible = false
    },

    // 获取裁判列表
    getScoreUserList() {
      let self = this
      getScoreUserList({start_id: self.userFormData.start_id}).then(res => {
        let data = self.scoreUserList = res.data.list
        self.caipanTypeNum = res.data.caipan_num

        // 处理普通裁判数据
        let arrayA = [],
            arrayB = [],
            caipanLeaderList = [],
            caipanLeaderViceList = [],
            caipanArbTorList = [],
            caipanArbList = [],
            caipanTecList = [],
            caipanNoteList = [],
            list = [
              {index: 0, show: false},
              {index: 1, show: false},
              {index: 2, show: false},
              {index: 3, show: false},
              {index: 4, show: false},
              {index: 5, show: false},
              {index: 6, show: false},
              {index: 7, show: false},
              {index: 8, show: false},
              {index: 9, show: false},
            ],
            listB = [
              {index: 0, show: false},
              {index: 1, show: false},
              {index: 2, show: false},
              {index: 3, show: false},
              {index: 4, show: false},
              {index: 5, show: false},
              {index: 6, show: false},
              {index: 7, show: false},
              {index: 8, show: false},
              {index: 9, show: false},
            ]
        console.log('self.defaultCaipanList', self.defaultCaipanList)

        // 拿出裁判长 和其他特殊裁判
        data.map(user => {
          if (user.type == '裁判长') {
            caipanLeaderList.push(user)
          } else if (user.type == '副裁判长') {
            caipanLeaderViceList.push(user)
          } else if (user.type == '仲裁主任') {
            caipanArbTorList.push(user)
          } else if (user.type == '仲裁委员') {
            caipanArbList.push(user)
          } else if (user.type == '技术监督') {
            caipanTecList.push(user)
          } else if (user.type == '记录裁判') {
            caipanNoteList.push(user)
          }
        })

        list.map((caipan, index) => {
          data.map((row) => {
            if (row.jgroup == 0 && row.type == '裁判') {
              if (row.index == index) {
                arrayA[index] = row
              } else if (!arrayA[index]) {
                arrayA[index] = caipan
              }
            }
          })
        })

        listB.map((caipan, index) => {
          data.map((row) => {
            if (row.jgroup == 1 && row.type == '裁判') {
              if (row.index == index) {
                row.show = false
                arrayB[index] = row
              } else if (!arrayB[index]) {
                arrayB[index] = caipan
              }
            }
          })
        })

        if (arrayA.length == 0) arrayA = list
        if (arrayB.length == 0) arrayB = listB

        self.scoreUserAList = arrayA
        self.scoreUserBList = arrayB
        self.caipanLeaderList = caipanLeaderList
        self.caipanLeaderViceList = caipanLeaderViceList
        self.caipanArbTorList = caipanArbTorList
        self.caipanArbList = caipanArbList
        self.caipanTecList = caipanTecList
        self.caipanNoteList = caipanNoteList

        self.caipanSaveLoading = false
        console.log(arrayA, arrayB, data)
      })
    },

    addUser() {
      let self = this

      // if (!self.userFormData.user_id) {
      //     self.$message.error('请选择人员')
      //     return
      // }
      if (!self.userFormData.name) {
        self.$message.error('请输入真实姓名')
        return
      }
      if (!self.userFormData.type) {
        self.$message.error('请选择类型')
        return
      }
      addScoreUser(self.userFormData)
          .then(res => {
            switch (self.userFormData.type) {
              case '裁判长':
                self.caipanLeaderShow = false
                break
              case '副裁判长':
                self.caipanLeaderViceShow = false
                break
              case '仲裁主任':
                self.caipanArbTorShow = false
                break
              case '仲裁委员':
                self.caipanArbShow = false
                break
              case '技术监督':
                self.caipanTecShow = false
                break
              case '记录裁判':
                self.caipanNoteShow = false
                break
            }

            self.userFormData.user_id = undefined
            self.userFormData.type = undefined

            self.caipanInputName = ''
            self.$message.success('新增成功')
            self.getScoreUserList()
          })
          .catch(err => {
            self.$message.error(err.data.msg)
          })
    },
    deleteUser(record, index) {
      let self = this
      deleteScoreUser({
        user_id: record.user_id,
        num: record.num,
        start_id: record.start_id
      })
          .then(res => {
            record.show = false
            // record.num = ''
            // record.id = 0
            self.$message.success('删除成功')

            // if(record.jgroup == 0) {
            //   self.scoreUserAList.splice(index, 1)
            // }

            // console.log(record)

            self.defaultCaipanBList = self.defaultCaipanList = [
              {index: 0, show: false},
              {index: 1, show: false},
              {index: 2, show: false},
              {index: 3, show: false},
              {index: 4, show: false},
              {index: 5, show: false},
              {index: 6, show: false},
              {index: 7, show: false},
              {index: 8, show: false},
              {index: 9, show: false},
            ]

            self.getScoreUserList()
          })
          .catch(err => {
            self.$message.error(err.data.msg)
          })
    },


    setStatus(status, record) {
      let self = this;
      setStatus({
        id: record.id,
        status: status
      })
          .then(res => {
            self.$refs.table.refresh()
          })
          .catch(err => {
            self.$message.error(err.data.msg)
          })
    },


    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    onTimeSelectChange(selectedRowKeys, selectedRows) {
      this.selectedTimeRowKeys = selectedRowKeys
      this.selectedTimeRows = selectedRows

      console.log(selectedRowKeys, selectedRows)
    },

    onCaipanChange() {
      let that = this,
          list = that.mingdanSelectedList
      // that.caipanChecked = that.caipanChecked ? false : true

      console.log(that.caipanChecked)
      // if (that.caipanTypeNum < 2) {
      //     that.$message.error('请先设置多组裁判')
      //     that.caipanChecked = false
      // }
      // this.onSubjectCaipanSet()

      if (!that.caipanChecked) {
        // 将所有的项目都 设置为A裁判
        list.map(row => {
          row.jgroup = 0
        })
      }

    },

    onCaipanChoiceChange() {
      this.onSubjectCaipanSet()
    },

    // 设置单个裁判
    onSubjectCaipanRowSet(row) {
      let that = this
      row.jgroup = row.jgroup == 0 ? 1 : 0
    },

    // 批量设置裁判
    onSubjectCaipanSet() {
      let that = this,
          checked = that.caipanChoiceChecked,
          list = that.mingdanSelectedList

      /**
       * checked
       * 为true A组裁判，list中group偶数为0，奇数为1
       * 反之亦然
       */
      list.map((row, rowIndex) => {
        if (checked) {
          if (rowIndex % 2 == 0) {
            row.jgroup = 0

          } else {
            row.jgroup = 1
          }
        } else {
          if (rowIndex % 2 == 0) {
            row.jgroup = 1
          } else {
            row.jgroup = 0
          }
        }
      })

    },


    onTimeTotalChange(time, timeString) {
      let that = this
      that.saiTimeTotal = timeString ? timeString : '00:00:00'

      console.log(time, timeString, that.formData.saiTime)

    },

    onTimeChange1(time, timeString) {

      let that = this
      that.timeData.checkTime1 = timeString ? timeString : '00:00:00'
    },
    onTimeChange2(time, timeString) {

      let that = this
      that.timeData.checkTime2 = timeString ? timeString : '00:00:00'
    },
    onTimeChange3(time, timeString) {

      let that = this
      that.timeData.checkTime3 = timeString ? timeString : '00:00:00'
    },
    onSaiTimeChange(time, timeString) {

      let that = this
      that.timeData.saiTime = timeString ? timeString : '00:00:00'
    },

    // 批量设置时间
    onBatchTime() {
      let that = this,
          time = that.timeData,
          list = that.mingdanSelectedList

      if (list.length == 0) {
        that.$message.error('请至少选择一个项目')
        return
      }

      // 判断是否有选中的 若有则只设置选中的值
      let keys = that.selectedTimeRowKeys,
          keyList = that.mingdanTargetKeys
      if (keys.length > 0) {
        // todo 获取最小key以后 循环遍历以后的全都根据时间间隔顺延
        let min = Math.max(...keys),
            minIndex = keyList.indexOf(min)

        console.log(min, minIndex, keyList)

        list.map((row, index) => {
          if (index != 0 && index >= minIndex) {
            row.check_time = that.getTimeSecond(list[index - 1].check_time) ? that.formatTimeToTime(list[index - 1].check_time, time.timeSpan) : '00:00:00'
            row.check_time2 = that.getTimeSecond(list[index - 1].check_time2) ? that.formatTimeToTime(list[index - 1].check_time2, time.timeSpan) : '00:00:00'
            row.check_time3 = that.getTimeSecond(list[index - 1].check_time3) ? that.formatTimeToTime(list[index - 1].check_time3, time.timeSpan) : '00:00:00'
            row.sai_time = that.getTimeSecond(list[index - 1].sai_time) ? that.formatTimeToTime(list[index - 1].sai_time, time.timeSpan) : '00:00:00'
          }

          // keys.map((key, keyIndex) => {

          // if (key == row.key) {
          //   console.log(time.timeSpan, key, row)
          //
          //   if (index == 0) {
          //     row.check_time = that.getTimeSecond(time.checkTime1) ? that.formatTimeToTime(time.checkTime1, keyIndex * time.timeSpan) : '00:00:00'
          //     row.check_time2 = that.getTimeSecond(time.checkTime2) ? that.formatTimeToTime(time.checkTime2, keyIndex * time.timeSpan) : '00:00:00'
          //     row.check_time3 = that.getTimeSecond(time.checkTime3) ? that.formatTimeToTime(time.checkTime3, keyIndex * time.timeSpan) : '00:00:00'
          //     row.sai_time = that.getTimeSecond(time.saiTime) ? that.formatTimeToTime(time.saiTime, keyIndex * time.timeSpan) : '00:00:00'
          //   } else {
          //     row.check_time = that.getTimeSecond(list[index - 1].check_time) ? that.formatTimeToTime(list[index - 1].check_time, time.timeSpan) : '00:00:00'
          //     row.check_time2 = that.getTimeSecond(list[index - 1].check_time2) ? that.formatTimeToTime(list[index - 1].check_time2, time.timeSpan) : '00:00:00'
          //     row.check_time3 = that.getTimeSecond(list[index - 1].check_time3) ? that.formatTimeToTime(list[index - 1].check_time3, time.timeSpan) : '00:00:00'
          //     row.sai_time = that.getTimeSecond(list[index - 1].sai_time) ? that.formatTimeToTime(list[index - 1].sai_time, time.timeSpan) : '00:00:00'
          //   }
          //
          // }
          // })
        })

        // 移除选中key
        that.selectedTimeRowKeys = []
        that.selectedTimeRows = []

      } else {

        console.log('key00')


        // 设置所有项目的 时间
        // 等差数列加时间是一个问题
        list.map((row, keyIndex) => {

          row.check_time = that.getTimeSecond(time.checkTime1) ? that.formatTimeToTime(time.checkTime1, keyIndex * time.timeSpan) : '00:00:00'
          row.check_time2 = that.getTimeSecond(time.checkTime2) ? that.formatTimeToTime(time.checkTime2, keyIndex * time.timeSpan) : '00:00:00'
          row.check_time3 = that.getTimeSecond(time.checkTime3) ? that.formatTimeToTime(time.checkTime3, keyIndex * time.timeSpan) : '00:00:00'
          row.sai_time = that.getTimeSecond(time.saiTime) ? that.formatTimeToTime(time.saiTime, keyIndex * time.timeSpan) : '00:00:00'

        })
      }

      that.$message.success('设置成功')
      console.log(list)
    },

    formatTimeToTime(time, minute, minutePen = 0) {
      // let time = '03:58:00',
      //     minute = 3,
      let date = '',
          today = new Date(new Date().setHours(0, 0, 0, 0)).getTime()

      // 如何得到 03:33:00

      var hour = time.split(':')[0]
      var min = time.split(':')[1]
      var sec = time.split(':')[2]
      var s = Number(hour * 3600) + Number(min * 60) + Number(minute * 60) - Number(minutePen * 60) + Number(sec)

      let endTime = s * 1000 + today

      date = this.formatDate(endTime, 'h:m:s')
      console.log('formatTimeToTime', time, minute, minutePen, min, s, date)

      return date
    },

    getTimeMinute(time) {
      var hour = time.split(':')[0]
      var min = time.split(':')[1]
      // var sec = time.split(':')[2]
      var s = Number(hour * 3600) + Number(min * 60)

      return s
    },

    getTimeSecond(time) {
      var hour = time.split(':')[0]
      var min = time.split(':')[1]
      var sec = time.split(':')[2]
      var s = Number(hour * 3600) + Number(min * 60) + Number(sec)

      console.log(parseInt(s))
      return parseInt(s)
    },

    formatDate(num, format) {
      const formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
      const returnArr = [];
      const date = new Date(num);
      returnArr.push(date.getFullYear()); // 取得4位数的年份
      returnArr.push(this.formatNumber(date.getMonth() + 1)); // 取得日期中的月份，其中0表示1月，11表示12月
      returnArr.push(this.formatNumber(date.getDate())); // 返回日期月份中的天数（1到31）
      returnArr.push(this.formatNumber(date.getHours())); // 返回日期中的小时数（0到23）
      returnArr.push(this.formatNumber(date.getMinutes())); // 返回日期中的分钟数（0到59）
      returnArr.push(this.formatNumber(date.getSeconds())); // 返回日期中的秒数（0到59）

      for (const i in returnArr) {
        // 判断对象是否含有某个非继承属性
        if ({}.hasOwnProperty.call(returnArr, i)) {
          format = format.replace(formateArr[i], returnArr[i]); // 替换
        }
      }
      return format;
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : `0${n}`;
    },
    sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    downloadCaipan(start_id){ 
      window.open(setting.apiBaseURL +'/adminapi/dscore/caipanDownload?start_id='+start_id);
    },
    downloadCaipanSaiqu(saiqu){ 
      window.open(setting.apiBaseURL +'/adminapi/dscore/caipanDownload?saiqu='+saiqu);
    },
    checkDev8Limit(list){
      let that = this;
      let numNameHash = {};
      let numIndexHash = [];
      list.map((item,index) => {
        item.ydy_list.map((ydy,index2) =>{
          numNameHash[ydy.num+'-'] = ydy.name
          if(typeof numIndexHash[ydy.num+'-'] == 'undefined'){
            numIndexHash[ydy.num+'-'] = [index]
          }else{
          numIndexHash[ydy.num+'-'].push(index) 
          }
        })
      })
      console.log(numIndexHash);
      let error = [];
      for(let item in numIndexHash){ 
        if(item.length>1){
          let err = that.arrayDistance(numIndexHash[item],8)
          if(err.length>0){
            error.push({
              name:numNameHash[item],
              index:err
            })
          }
        }
      } 
      return error;
    },
    arrayDistance(array,limit){
      let error = false;
      let result = [];
      array.map((item,index) =>{
        if(index!=0){ //第1项不计算
          if(array[index] -array[index-1] <= limit){
            error = true;
            result = [array[index-1]+1,array[index]+1]
          }
        }
      })
      return result;
    },
    //同项目被拆开了
    subjectDivLimit(list){
      console.log(list);
      let error_subject = [];
      let subjectHash = {};
      let error = [];
      list.map((subject,index) => {
        // subject.subject_name;
        if(typeof subjectHash[subject.subject_name] == 'undefined' ){
          subjectHash[subject.subject_name] = [index+1]
        }else{
          if(index - subjectHash[subject.subject_name][ subjectHash[subject.subject_name].length-1] !=0 ){
            error_subject.push(subject.subject_name);
          }
          subjectHash[subject.subject_name].push(index+1)
        } 
      })
      error_subject.map(subject =>{
        error.push({
          name:subject,
          index: subjectHash[subject]
        })
      });
      console.log(error);
      return error;
    },

    setShow(status, record) {
      let self = this;
      setShow({
        id: record.id,
        show: status
      })
          .then(res => {
            self.$refs.table.refresh()
          })
          .catch(err => {
            self.$message.error(err.data.msg)
          })
    },
  },
  filters: {},
  watch: {}
}
</script>
<style scoped>
.tree {  
    position: relative;  
    width: 300px;  
    height: 300px;  
    border: 1px solid #ccc;  
    margin: 20px;  
}  
  
.node {  
    position: absolute;  
    width: 40px;  
    height: 40px;  
    line-height: 40px;  
    text-align: center;  
    border: 1px solid black;  
    background-color: white;  
    /* 使用border模拟连接线，但这里仅作为节点本身 */  
}  
  
/* 这不是真正的连接线，只是通过样式来模拟。对于真正的连接线，可能需要SVG或Canvas */  
/* 下面是一些简单的样式调整，帮助可视化 */  
.node:nth-child(2), .node:nth-child(3) {  
    border-top: 2px solid black; /* 顶部连接 */  
}  
  
.node:nth-child(4), .node:nth-child(5) {  
    border-left: 2px solid black; /* 左连接 */  
}  
  
.node:nth-child(6), .node:nth-child(7) {  
    border-right: 2px solid black; /* 右连接 */  
}  
  
/* 注意：以上CSS只是示例，并不能准确表示所有连接线 */
</style>


<style type="text/css" scoped>
  .container
  {
      border:1px solid red;
      width: 300px;
      height: 300px;
  } 
</style>